import { gql } from '@apollo/client';

export const CREATE_ARBEITSBEREICH_STATION = gql(`
  mutation rotationsplan_createArbeitsbereichStation($input: mitarbeiter_createArbeitsbereichStationInput!) {
   mitarbeiter_createArbeitsbereichStation(input: $input){
    error {
      message
    }
    station {
      ... on mitarbeiter_rotationsplanArbeitsbereichStation {
        von
        bis
        id
         bereichsleiter {
          id
          nachname
          vorname
          bildUrl
         }
         arbeitsbereich {
          id
          name
          markierung
         }
      }
    }
   }
  }
`);
